import { library as fontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faCircle } from '@fortawesome/free-regular-svg-icons'

import {
  faAngleDown,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faBackspace,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCircle as faCircleSolid,
  faCompress,
  faExpand,
  faExpandArrowsAlt,
  faHeart,
  faList,
  faPaperPlane,
  faPause,
  faPauseCircle,
  faPlay,
  faPlayCircle,
  faPlus,
  faQuestion,
  faRedo,
  faSearch,
  faSlidersH,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faUndo,
} from '@fortawesome/free-solid-svg-icons'

import {
  faInboxIn,
  faLockAlt,
  faLockOpenAlt,
  faVolume,
  faVolumeSlash,
} from '@fortawesome/pro-solid-svg-icons'
import { faPen } from '@fortawesome/pro-regular-svg-icons'

fontAwesomeLibrary.add(
  faAngleDown,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faBackspace,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleSolid,
  faCompress,
  faExpand,
  faExpandArrowsAlt,
  faHeart,
  faInboxIn,
  faList,
  faLockAlt,
  faLockOpenAlt,
  faPaperPlane,
  faPause,
  faPauseCircle,
  faPen,
  faPlay,
  faPlayCircle,
  faPlus,
  faQuestion,
  faRedo,
  faSearch,
  faSlidersH,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faUndo,
  faVolume,
  faVolumeSlash
)

export default {
  install(Vue) {
    Vue.component('FontAwesomeIcon', FontAwesomeIcon)
  },
}
